import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import Menu from '@/views/Menu.vue'
import Login from '@/views/Login.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/menu/',
    component: Menu,
    children: [
      {
        path: '',
        redirect: '/login'
      },
      {
        path: 'informacion',
        name: 'Informacion',
        component: () => import('@/views/Informacion.vue')
      },
      {
        path: 'turnos',
        name: 'Turnos',
        component: () => import('@/views/turnos/Turnos.vue')
      },

      /* RUTAS USUARIO REPORTES */
      {
        path: 'reportes',
        redirect: '/menu/resportes/reportes'
      },
      {
        path: 'reportes/reportes',
        name: 'Reportes_Sistema',
        component: () => import('@/views/reportes/Reportes.vue')
      },

      /* RUTAS USUARIO ADMINISTRADOR */
      {
        path: 'administrador',
        redirect: '/menu/soporte/eventos'
      },
      {
        path: 'administrador/usuarios',
        name: 'Administrador_Usuarios',
        component: () => import('@/views/administrador/Usuarios.vue')
      },
      {
        path: 'administrador/tipos_eventos',
        name: 'Administrador_Tipos_Eventos',
        component: () => import('@/views/administrador/TiposEventos.vue')
      },

      /* RUTAS USUARIOS SOPORTE */
      {
        path: 'soporte',
        redirect: '/menu/soporte/eventos'
      },
      {
        path: 'soporte/eventos',
        name: 'Soporte_Eventos',
        component: () => import('@/views/soporte/Eventos.vue')
      },
      {
        path: 'soporte/historial',
        name: 'Soporte_Historial',
        component: () => import('@/views/soporte/Historial.vue')
      },
      /* ###################### */


      /*  RUTAS USUARIO NORMAL  */
      {
        path: 'normal',
        redirect: '/menu/normal/pendientes'
      },
      {
        path: 'normal/pendientes',
        name: 'Normal_Pendientes',
        component: () => import('@/views/normal/Pendientes.vue')
      },
      {
        path: 'normal/historial',
        name: 'Normal_Historial',
        component: () => import('@/views/normal/Historial.vue')
      },
      /* ###################### */

      /*  RUTAS PARA VISTA DE ERROR */
      {
        path: '/error_conexion',
        name: 'Error_Conexion',
        component: () => import('@/views/ErrorConexion.vue')
      }
      /* ###################### */
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/informacion',
    name: 'Info',
    component: () => import('@/views/Informacion.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
